import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
// import Pagination from './pagination'
import LeadDetailTabs from './LoanFiledTabs';
import ReactPaginate from 'react-paginate';
import { executeGraphQLMutation } from '../../../services/inventory-funding/executeGraphQLQuery';
import { ASSIGN_OPSEE_TASK, GET_CUSTOMER_DETAILS, UPDATE_TASK_STATUS } from '../../../services/inventory-funding/opsee.gql';
import { useApolloClient } from '@apollo/client';
import { toast } from 'react-toastify';
import crypto from "../../../config/crypto";
import { Link } from 'react-router-dom';
import { FCI_ADMIN_ACCESS_ROLE } from '../../../config/IFConstant';
import SurveyPDF from './SurveyPDF';
import { executeGraphQLQuery } from '../../../common/executeGraphQLQuery';

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {props.selectProps.placeholder}
            </Placeholder>
            {React.Children.map(children, child =>
                child && child.type !== Placeholder ? child : null
            )}
        </ValueContainer>
    );
};

const REOPEN_REASONS = [
  {
    id: 1,
    label: "Customer Now Interested",
    value: "Customer Now Interested"
  },
  {
    id: 2,
    label: "Customer Available for Verification",
    value: "Customer Available for Verification"
  },
  {
    id: 3,
    label: "Customer Requested Revisit",
    value: "Customer Requested Revisit"
  },
  {
    id: 4,
    label: "Incorrect Rejection",
    value: "Incorrect Rejection"
  },
  {
    id: 5,
    label: "Data Updated / Corrected",
    value: "Data Updated / Corrected"
  },
  {
    id: 6,
    label: "Admin Approval for Reopen",
    value: "Admin Approval for Reopen"
  },
  {
    id: 7,
    label: "Exception Case Approval",
    value: "Exception Case Approval"
  },
  {
    id: 8,
    label: "Credit Decision Reconsidered",
    value: "Credit Decision Reconsidered"
  },
  {
    id: 9,
    label: "Additional Documents Received",
    value: "Additional Documents Receive"
  },
  {
    id: 10,
    label: "Risk Reassessment Approved",
    value: "Risk Reassessment Approved"
  },
  {
    id: 0,
    label: "Other (Requires Comment)",
    value: "Other"
  }
];
const LeadListTable = (props) => {
  const client = useApolloClient();
  let pageCount = Math.ceil(props.pageCount / 10);
  let taskViewList = props.taskViewList;

  const [customerDetails, setCustomerDetails] = useState({});
  const [rejectModal, setRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState({});

  const [reopenModal, setReopenModal] = useState(false);
  const [reopenReason, setReopenReason] = useState({});

  useEffect(()=> {
    if(Object.keys(customerDetails).length) {
      const element = document.getElementById("survey-pdf");
      const opt = {
        margin: 10,
        filename: `Survey Report - ${customerDetails?.pb_full_name}_${customerDetails?.id}`,
        html2canvas: { scale: 2 ,useCORS: true, allowTaint: true },
        jsPDF: { unit: "mm", format: "a4" },
      };

      window.html2pdf().set(opt).from(element).save();
    }
  },[customerDetails])

  const handleChangeAssign = (task_id,e) => {
   if(window.confirm(`Do you want to assign Task ID: ${task_id} to ${e.label}?`)) {
    props.setLoading(true);
    let variables= {
        "assignTaskInput": {
        "assign_to": +e.value,
        "task_id": +task_id
      }
    }
    executeGraphQLMutation(ASSIGN_OPSEE_TASK(),variables,client).then(res=> {
        toast.success(res?.data?.assign_opsee_task?.message);
        props.getTaskViewList(props.filterData,props.offset)
        props.setLoading(false)
    }).catch(error=> {
        props.setLoading(false)
        toast.error(error.toString().replace('ApolloError:',''));
    })
   }
  };

  const cancelTask = () => {
    props.setLoading(true);
    let variables= {
      "updateTaskInput": {
        source:"opsee",
        type: "reject",
        task_id:rejectReason?.task_id || 0,
        rejection_reasons: rejectReason?.id === 0 ? rejectReason?.other_reason : rejectReason?.value,
      }
    }
    executeGraphQLMutation(UPDATE_TASK_STATUS(),variables,client).then(res=> {
        hideRejectModal();
        toast.success(res?.data?.update_task_status?.message);
        props.getTaskViewList(props.filterData,props.offset)
        props.setLoading(false)
    }).catch(error=> {
        props.setLoading(false)
        toast.error(error.toString().replace('ApolloError:',''));
    })
  };

  const reopenTask = () => {
    props.setLoading(true);
    let variables= {
      "updateTaskInput": {
        source:"opsee",
        type: "reopen",
        task_id:reopenReason?.task_id || 0,
        reopen_reasons: reopenReason?.id === 0 ? reopenReason?.other_reason : reopenReason?.value,
      }
    }
    executeGraphQLMutation(UPDATE_TASK_STATUS(),variables,client).then(res=> {
        hideReopenModal();
        toast.success(res?.data?.update_task_status?.message);
        props.getTaskViewList(props.filterData,props.offset)
        props.setLoading(false)
    }).catch(error=> {
        props.setLoading(false)
        toast.error(error.toString().replace('ApolloError:',''));
    })
  };

  const showRejectModal = (task_id) => {
    setRejectReason({task_id})
    setRejectModal(true);
    document.body.classList.add("overflow-hidden");
  }

  const hideRejectModal = () => {
    setRejectModal(false);
    setRejectReason({});  
    document.body.classList.remove('overflow-hidden');
  };

  const showReopenModal = (task_id) => {
    setReopenReason({task_id})
    setReopenModal(true);
    document.body.classList.add("overflow-hidden");
  }

  const hideReopenModal = () => {
    setReopenModal(false);
    setReopenReason({});  
    document.body.classList.remove('overflow-hidden');
  };

  const handlePagenationClick = (e) => {
    const selectedPage = e.selected;
    props.handlePageClick(selectedPage);
};

  const handleDownload = async (customer_id,task_id=0) => {
    props.setLoading(true);
    let variables = {
      customerDetailsInput: {
        source: 'opsee',
        customer_id: customer_id
      }
    };
    if(task_id > 0) variables['customerDetailsInput']['task_id'] = task_id;
    console.log("*************200",customer_id,task_id)
    executeGraphQLMutation(GET_CUSTOMER_DETAILS(),variables, client)
    .then((res) => {
    if(res?.data){
      props.setLoading(false);
      setCustomerDetails(res?.data?.customer_details);
    }else{
      props.setLoading(false);
      toast.error("Something went wrong")
    }
    })
    .catch((error) => {
      props.setLoading(false);
        toast.error(error.toString().replace('ApolloError:',''));
    })
  }
  console.log("*************88187",customerDetails)
  return (
    <>
      <div className="lead-list-data-table fci-list-table">
        <table>
          <thead>
            <tr>
              <th>Task ID</th>
              <th>Primary Borrower</th>
              <th>Co-borrower</th>
              <th>Survey Type</th>
              <th>Survey Address</th>
              <th>Rescheduled</th>
              {["third"].includes(props.activeTab) && <th>TAT <br/>(Assigned-<br/>Acknowledged)</th>}
              {["fourth"].includes(props.activeTab) && <th>TAT <br/>(Acknowledged-<br/>Completed)</th>}
              <th>Assign to</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {taskViewList?.task_list?.length > 0 ? (
                taskViewList.task_list.map((task) => (
                <tr key={task.id}>
                    <td>{task.id} <span className={`lead-type ${task.lead_type === 'if' ? 'lead-type-bg' : ''}`}>{task.lead_type}</span>
                    </td>

                    {/* PB Details */}
                    <td>
                    <div className="table-txt-data">
                        <h5>{task.pb_full_name || '-'}</h5>
                        <span>{task.pb_mobile || '-'}</span>
                        <span>Created on {task.created_date}</span>
                    </div>
                    </td>

                    {/* CB Details */}
                    <td>
                    <div className="table-txt-data">
                        <h5>{task.cb_full_name || '-'}</h5>
                        <span>{task.cb_mobile || '-'}</span>
                    </div>
                    </td>

                    {/* Survey Type */}
                    <td>{task.name || '-'}</td>

                    {/* Address */}
                    <td>{task.address || '-'}</td>

                    <td>
                    <div className="table-txt-data">
                        <h5>{task.other_reason ? 'Yes' : 'No'}</h5>
                        <span>{task.reschedule_date || '-'}</span>
                        <span>Reason: {task.other_reason || '-'}</span>
                    </div>
                    </td>

                    {["third"].includes(props.activeTab) && <td>{task.assigned_acknowledged_tat}</td>}
                    {["fourth"].includes(props.activeTab) && <td>{task.acknowledged_completed_tat}</td>}

                    {/* Assign To */}
                    <td>
                    <fieldset className="single-select">
                        <div className="material">
                        <Select
                            value={props.userList.filter(v=> +v.value === task.assigned_to)}
                            onChange={(e) => handleChangeAssign(task.id,e)}
                            options={props.userList}
                            isDisabled={!["first","second","fifth"].includes(props.activeTab)}
                            placeholder="Assign To"
                            className="react-select"
                            classNamePrefix="react-select"
                        />
                        </div>
                    </fieldset>
                    </td>

                    {/* Actions */}
                    <td>
                    <ul className="action-btn">
                        <li>
                        <Link
                            to={`/inventory-funding/fci-lead-detail/${crypto.encode(task.customer_id)}`}
                            className="btn btn-default"
                        >
                            <i className="ic-remove_red_eyevisibility"></i>
                        </Link>
                        </li>
                        {(props?.logInUserInfo?.role_id?.includes(FCI_ADMIN_ACCESS_ROLE) || props?.logInUserInfo?.role_id?.includes(-1)) &&
                        <>
                          {["sixth"].includes(props.activeTab) ? 
                          <li onClick={()=> showReopenModal(task.id)} title='Reopen Task'>
                            <i className='ic-replay'></i>
                          </li>
                          :
                          <li onClick={()=> showRejectModal(task.id)} title='Reject Task'>
                          <i className="ic-rejected">
                            <i className='path1'></i>
                              <i className='path2'></i>
                              <i className='path3'></i>
                              <i className='path4'></i>
                              <i className='path5'></i>
                              <i className='path6'></i>
                              <i className='path7'></i>
                              <i className='path8'></i>
                          </i>
                          </li>
                          }
                        </>}
                        <div style={{ display: 'none' }}>
                          {customerDetails && <SurveyPDF data={customerDetails} />}
                        </div>
                        {["fourth"].includes(props.activeTab) &&
                          <li title='Download Survey' onClick={()=> handleDownload(task.customer_id,task.id)}>
                            <i className='ic-save_alt'></i>
                          </li>
                        }
                    </ul>
                    </td>
                </tr>
                ))
            ) : (
                <tr>
                <td colSpan="8" className="text-center">
                    No records found
                </td>
                </tr>
            )}
          </tbody>

        </table>
        <div className='pagination-bx' id="dealerList">
                    <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        forcePage = {props.offset}
                        pageRangeDisplayed={5}
                        onPageChange={handlePagenationClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
                </div >
      </div>

      <div className="view-login-popup caluction-popup-outer cancellation-flow">
        <Modal
          show={rejectModal}
          handleClose={hideRejectModal}
        >
          <div className='mrp-heading-txt'>
          <h2 className='mmvdetailsph-title'>Cancel Task</h2>
          </div>
          <div className="modal-header">
          </div>
          <div className="modal-body">
            <fieldset className="single-select">
              <div className="material">
                <Select
                  components={{ ValueContainer: CustomValueContainer }}
                  options={taskViewList?.rejection_reasons}
                  placeholder="Cancel Reasons"
                  className="react-select"
                  classNamePrefix="react-select"
                  value={taskViewList?.rejection_reasons?.filter(v=> v.value === rejectReason?.value)}
                  onChange={(e) =>
                    setRejectReason((prev)=>({...prev,id:e.id,value:e.value,}))
                  }
                />
              </div>
            </fieldset>
            &nbsp;
            &nbsp;
            {rejectReason?.id === 0 && 
            <fieldset className="form-filed">
              <div className="material">
                <input
                  id="value"
                  type="text"
                  placeholder=""
                  name="value"
                  className="form-input"
                  autoComplete="off"
                  value={rejectReason?.other_reason}
                  onChange={(e)=> setRejectReason((prev)=>({...prev,id:0,value:rejectReason?.value,other_reason:e.target.value}))}
                />
                <label
                  data-label="Other (Requires Comment)"
                  className="form-label"
                ></label>
              </div>
            </fieldset>}
          </div>
          <div className="btn-save-remarks m-lg-t">
            <button type="button" className="btn-primary" onClick={()=>cancelTask()} disabled={rejectReason?.id === 0 ? !rejectReason?.other_reason : !rejectReason?.value}>
              Save
            </button>
          </div>
        </Modal>
      </div>

      <div className="view-login-popup caluction-popup-outer cancellation-flow">
        <Modal
          show={reopenModal}
          handleClose={hideReopenModal}
        >
          <div className='mrp-heading-txt'>
          <h2 className='mmvdetailsph-title'>Reopen Task</h2>
          </div>
          <div className="modal-header">
          </div>
          <div className="modal-body">
            <fieldset className="single-select">
              <div className="material">
                <Select
                  components={{ ValueContainer: CustomValueContainer }}
                  options={REOPEN_REASONS}
                  placeholder="Reopen Reasons"
                  className="react-select"
                  classNamePrefix="react-select"
                  value={REOPEN_REASONS?.filter(v=> v.value === reopenReason?.value)}
                  onChange={(e) =>
                    setReopenReason((prev)=>({...prev,id:e.id,value:e.value,}))
                  }
                />
              </div>
            </fieldset>
            &nbsp;
            &nbsp;
            {reopenReason?.id === 0 && 
            <fieldset className="form-filed">
              <div className="material">
                <input
                  id="value"
                  type="text"
                  placeholder=""
                  name="value"
                  className="form-input"
                  autoComplete="off"
                  value={reopenReason?.other_reason}
                  onChange={(e)=> setReopenReason((prev)=>({...prev,id:0,value:reopenReason?.value,other_reason:e.target.value}))}
                />
                <label
                  data-label="Other (Requires Comment)"
                  className="form-label"
                ></label>
              </div>
            </fieldset>}
          </div>
          <div className="btn-save-remarks m-lg-t">
            <button type="button" className="btn-primary" onClick={()=>reopenTask()} disabled={reopenReason?.id === 0 ? !reopenReason?.other_reason : !reopenReason?.value}>
              Save
            </button>
          </div>
        </Modal>
      </div>
    </>
  );
};

const Modal = ({ handleClose, show, children }) => {
  const showHideClassName = show
    ? 'modal display-block'
    : 'modal display-none';

  return (
    <div className={showHideClassName}>
      <section className="modal-main">
        {children}
        <button
          onClick={handleClose}
          className="close_icn"
        >
          <i className="ic-clearclose"></i>
        </button>
      </section>
    </div>
  );
};

export default LeadListTable;
